import React from "react";
import PdfJsRenderer from "./PdfJsRenderer";
import IframePdfRenderer from "./IframePdfRenderer";

const isEdge = window.navigator && window.navigator.msSaveOrOpenBlob;

const PdfRenderer = ({ workItemId, type, token }) => {
  return isEdge ? (
    <PdfJsRenderer className="pdf-viewer" workItemId={workItemId} type={type} />
  ) : (
    <IframePdfRenderer
      style={{ height: "calc(100% - 84px)" }}
      workItemId={workItemId}
      type={type}
      token={token}
    />
  );
};

export default PdfRenderer;
